import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Box, ButtonBase, useTheme } from '@mui/material';
import { IconTestPipe } from '@tabler/icons-react';

import { Typography } from '@zendesk/forethought-elements';
import { getAbTestDetailPath } from 'src/components/dashboard-pages/solve-insights/common/abTestUtils';
import { AB_TEST_GRADIENT } from 'src/constants/colors';
import { ABTestVariantInfo } from 'src/services/insights/types';

interface AbTestTopBannerProps {
  activeAbTest: ABTestVariantInfo;
}

const formatEndDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const AbTestTopBanner = ({ activeAbTest }: AbTestTopBannerProps) => {
  const { t } = useTranslation('workflow-builder-edit');
  const { palette, spacing } = useTheme();
  const navigate = useNavigate();

  const bannerText = activeAbTest.end_date
    ? t('abTestTopBanner.activeTestUntil', {
        date: formatEndDate(activeAbTest.end_date),
      })
    : t('abTestTopBanner.activeTest');

  return (
    <Box
      sx={{
        alignItems: 'center',
        background: AB_TEST_GRADIENT,
        display: 'flex',
        gap: 1,
        height: spacing(4.5),
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: palette.colors.white,
          borderRadius: '12px',
          display: 'flex',
          height: '24px',
          justifyContent: 'center',
          width: '24px',
        }}
      >
        <IconTestPipe color={palette.colors.grey[700]} size={15} />
      </Box>
      <Typography color={palette.colors.black} variant='font14Bold'>
        {bannerText}
      </Typography>
      <ButtonBase
        onClick={() =>
          navigate(getAbTestDetailPath(activeAbTest.ab_test_config_id))
        }
      >
        <Typography color={palette.colors.teal[500]} variant='font14Bold'>
          {t('abTestTopBanner.viewTest')}
        </Typography>
      </ButtonBase>
    </Box>
  );
};
